<template>
  <div>
    <!-- optional indicators -->
    <i class="fa fa-circle-o-notch fa-spin" v-if="loading"></i>
    <template v-else>
      <i class="fa fa-search" v-show="isEmpty"></i>
      <i class="fa fa-times" v-show="isDirty" @click="reset"></i>
    </template>

    <!-- the input field -->
    <input class="form-control ml-sm-1 mr-sm-4"
           type="text"
           size="40"
           placeholder="search"
           autocomplete="off"
           v-model="query"
           @keydown.down="down"
           @keydown.up="up"
           @keydown.enter="hit"
           @keydown.esc="reset"
           @blur="reset"
           @input="update"/>

    <!-- the list -->
    <ul class="typeahead" v-show="hasItems">
      <!-- for vue@1.0 use: ($item, item) -->
      <li v-bind:key="item" v-for="(item, $item) in items" :class="activeClass($item)" @mousedown="hit" @mousemove="setActive($item)">
        <router-link :to="{ name: 'Detail', params: { id: item._source.id }}"><span v-text="item._source.apn"></span>&nbsp;<span v-text="item._source.name"></span></router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import VueTypeahead from "vue-typeahead";
import Axios from "axios";
import Vue from "vue";
import router from "../router";

Vue.prototype.$http = Axios;

export default {
  name: "search-box",
  extends: VueTypeahead,
  data() {
    return {
      src: "/api/search/",
      data: {},
      limit: 10,
      minChars: 3,

      // Highlight the first item in the list
      // (optional)
      selectFirst: false,

      // Override the default value (`q`) of query parameter name
      // Use a falsy value for RESTful query
      // (optional)
      queryParamName: "search"
    };
  },

  methods: {
    onHit(item) {
      router.push({ name: "Detail", params: { id: item._id } });
    },

    // The callback function which is triggered when the response data are received
    // (optional)
    prepareResponseData(data) {
      return data.hits.hits;
    }
  }
};
</script>

<style>
.typeahead {
  position: absolute;
  background-color: #f7f7f7;
  padding: 2em;
  list-style-type: none;
  z-index: 1000;
}
.typeahead li:hover {
  background-color: #ffff00;
}
</style>
